<template>    
    <BaseModal
        :id="'static-last-complete'"
        :size="'lg'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_body_object"
                    :array_options="array_options"
                    :for_update="false"
                />
                <CentralLiteButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>
import FormResources       from './form_resources'
import FormDynamic         from '@/components/FormDynamic.vue'
import Breadcrumb          from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal           from '@/components/BaseModal'
import CentralLiteButtons  from '@/components/CentralLiteButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "breadcrumb",
        "rest_api",
        "single_body_object",
        "body_index",
        "notyf",
        "array_options",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data(){
        return{
            // form_data: FormResources.form_data,
            form_format: FormResources.form_format,
            form_backup: {...FormResources.form_data},
        }
    },

    methods:{

        form_submit_update()
        {
            let object = {
                index: this.body_index,
                room: this.single_body_object,
            }

            this.$emit('CompletedReplacing', object)
        }

    },

    mounted(){

    }
    
}
</script>